import { render, staticRenderFns } from "./ListInterestedSchools.vue?vue&type=template&id=7f1ff84a&"
import script from "./ListInterestedSchools.vue?vue&type=script&lang=js&"
export * from "./ListInterestedSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports